import { useState } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { match } from 'ts-pattern';
import { useRouterEvents } from '../../../../hooks/useRouterEvents';
import { PrivacyJson } from '../../../../types/AccountsTypes';
import { AsideWithLayout } from '../../../layouts';
import { AsideWithLayoutMenusProp } from '../../../layouts/AsideWithLayout/AsideWithLayout';
import { PrivacyTerms } from './components/PrivacyTerms';
type PrivacyType = 'normal' | 'wallet';
const validateType = (queryString: string): PrivacyType => {
  return (['normal', 'wallet'] as PrivacyType[]).find(d => d === queryString) || 'normal';
};
export const Privacy = ({
  data
}: {
  data: Record<string, any>;
}) => {
  const {
    t
  } = useTranslation(['accounts']);
  const router = useRouter();
  const [privacyType, setPrivacyType] = useState<'normal' | 'wallet'>(validateType(String(router.query.type)));
  const [privacyItems] = useState<PrivacyJson>({
    privacy: data?.privacy,
    privacyWallet: data?.privacyWallet
  });
  const handleButtonClick = (type: PrivacyType) => {
    router.push({
      pathname: router.pathname,
      query: {
        type
      }
    }, undefined, {
      shallow: true
    }).then(() => {
      setPrivacyType(type); // routeChangeComplete 이벤트가 먹히는 이슈가 있어서 추가적으로 셋팅 실행
    });
  };
  useRouterEvents('routeChangeComplete', () => {
    /** 쿼리스트링 변경 시에 보여줄 내용 변경 처리(뒤로 가기, 앞으로 가기 대응) */
    setPrivacyType(validateType(String(router.query.type)));
  });
  const menuItems = (): AsideWithLayoutMenusProp => {
    const result = [{
      id: 'normal',
      isActive: privacyType === 'normal',
      render: <div style={{
        width: '100%',
        height: '100%'
      }} onClick={() => handleButtonClick('normal')}>
            {t('accounts:privacyPage.menu.zep')}
          </div>
    }, {
      id: 'wallet',
      isActive: privacyType === 'wallet',
      render: <div style={{
        width: '100%',
        height: '100%'
      }} onClick={() => handleButtonClick('wallet')}>
            {t('accounts:privacyPage.menu.zetaWallet')}
          </div>
    }];

    // if (locale === 'ja') return result.filter(d => d.id !== 'wallet');

    return result;
  };
  return <AsideWithLayout.Wrapper data-sentry-element="unknown" data-sentry-component="Privacy" data-sentry-source-file="Privacy.tsx">
      <AsideWithLayout.Container data-sentry-element="unknown" data-sentry-source-file="Privacy.tsx">
        <AsideWithLayout.SideButtons menuItems={menuItems()} data-sentry-element="unknown" data-sentry-source-file="Privacy.tsx" />
        <AsideWithLayout.Content data-sentry-element="unknown" data-sentry-source-file="Privacy.tsx">
          {match(privacyType).with('normal', () => <PrivacyTerms.Section data={privacyItems.privacy} />).with('wallet', () => <PrivacyTerms.Section data={privacyItems.privacyWallet} />).exhaustive()}
        </AsideWithLayout.Content>
      </AsideWithLayout.Container>
    </AsideWithLayout.Wrapper>;
};